import { render, staticRenderFns } from "./CarouselItem.vue?vue&type=template&id=77260dae&scoped=true&"
var script = {}
import style0 from "./CarouselItem.vue?vue&type=style&index=0&id=77260dae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77260dae",
  null
  
)

export default component.exports